import { Component, Input } from '@angular/core';
import { handbookChannelForHostname, resolveHandbookUrl } from '@shared/documentation/handbook-url';

@Component({
  selector: 'app-manual-link',
  standalone: true,
  templateUrl: './manual-link.component.html',
  styleUrls: ['./manual-link.component.scss']
})
export class ManualLinkComponent {

  @Input() private _href = "#";
  private readonly channel = handbookChannelForHostname(window.location.hostname);
  @Input() public set href(value: string) {
    this._href = resolveHandbookUrl(value, this.channel);
  }

  public get href(): string {
    return this._href;
  }




}
